import { Outlet, Navigate } from "react-router-dom";
import useAppStore from "@/stores/useAppStore";
import { SystemRoleEnum } from "@/types/enum";

function AdminRoute() {
  const user = useAppStore((s) => s.user);

  // Check if user is admin or super admin
  const isAdmin =
    user?.systemRole === SystemRoleEnum.ADMIN ||
    user?.systemRole === SystemRoleEnum.SUPER_ADMIN;

  if (!isAdmin) {
    return <Navigate to="/projects" replace />;
  }

  return <Outlet />;
}

export default AdminRoute;
